import React from 'react';
import { Box, Paper, Typography } from '@material-ui/core';
import { WithStyles } from '@material-ui/core/styles';
import CodeIcon from '@material-ui/icons/VpnKey';
import styles from './styles';
import { PropertiesActiveLocks } from '../../redux/types/properties';

type Props = {
  listLocks: PropertiesActiveLocks[],
} & WithStyles<typeof styles>;

export const ActivationLockList = (props: Props) => {
  const { classes, listLocks } = props;

  const formatDate = (isoString: string) => {
    const date = new Date(isoString);
    const month = date.toLocaleString('en-US', { month: 'short' });
    const day = date.getUTCDate();
    const hours = date.getUTCHours();
    const minutes = String(date.getUTCMinutes()).padStart(2, '0');
    const ampm = hours >= 12 ? 'PM' : 'AM';
    const hour12 = hours % 12 || 12;

    return `${month} ${day} · ${hour12}:${minutes} ${ampm}`;
  };

  return (
    <Paper className={classes.root}>
      <Box className={classes.header}>
        <Box className={classes.titleContainer}>
          <Typography component="span" className={classes.title}>Hardware List</Typography>
          <span className={classes.badge}>{listLocks.length}</span>
          <span className={classes.activePropertiesBadge}>Active Properties</span>
        </Box>
      </Box>

      <Box className={classes.listBody}>
        {listLocks.map((lock) => {
          const propertyAddress = `${lock.propertyAddress}, ${lock.city}, ${lock.state}`;
          return (
            <Box key={lock.propertyId} className={classes.item}>
              <Box className={classes.itemLeft}>
                <Box className={classes.iconWrap}>
                  <CodeIcon fontSize="small" className={classes.icon} />
                </Box>
                <Box>
                  <Box className={classes.name}>{lock.hubId ?? lock.smartId}</Box>
                  <Box className={classes.community}>{lock.communityName}</Box>
                  <Box className={classes.address}>{propertyAddress}</Box>
                  {lock.houseNumber && (
                    <Box className={classes.lot}>
                      <span>Lot</span>
                      <span>{lock.houseNumber}</span>
                    </Box>
                  )}
                  <Box className={classes.createdAt}>
                    {formatDate(lock.hubModifiedOn ?? lock.smartModifiedOn)}
                  </Box>
                </Box>
              </Box>
            </Box>
          );
        })}
      </Box>
    </Paper>
  );
};
